import apiProduct from '@/api/public/product-review';

const defaultState = () => ({
	productReview: [],
	loadProductReview: false,
	productReviewPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setProductReview(state, data) {
		state.productReview = [ ...data.data ]
		state.productReviewPagination = data.pagination;
	},
	setloadProductReview(state, data) {
		state.loadProductReview = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearProductReview(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getProductReview({ commit }, params) {
		commit('setloadProductReview', true);
		return new Promise((resolve) => {
			apiProduct.getProductReview(params).then(({ data: { data } }) => {
				commit('setProductReview', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setProductReview', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadProductReview', false);
			});
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};